import React from 'react';
import styled from 'styled-components';
import Dn from '../../assets/dn.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;

class CardSharks extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Coverbg src= {'https://frontiersinblog.files.wordpress.com/2020/01/frontiers-marine-science-estimating-global-catches-marine-recreational-fishes.jpg?w=1000'}/>        
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Dn}
   metricsm="Declining Globally"
   diagnosis="Overfishing and entanglement are damaging shark populations around the world. Sharks grow relatively slowly, take many years to mature and produce relatively few young."
   prediction="As top predators, sharks play an important role in balancing marine ecosystems. An overabundance at lower trophic levels of could deplete resources at the bottom of the food web (WWF)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardSharks;
